module.exports = __webpack_public_path__ + "static/wickes-a163db138ab693f0864984ff854d53e7.png";